import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import Header from '../components/Header';
import { Title, Subtitle } from '../components/Title';
import { NavButtons } from '../components/NavButtons';
import { Button } from '../components/Button';
import { getSubscription, getProducts, getFlashMessage } from '../store/selectors';
import {
  doFetchProducts,
  doFetchSubscription,
  doRequestUpdateProduct,
  doShowModal,
  doHideModal,
} from '../store/actions';
import ProductsList from '../components/Products/ProductsList';
import { postMessageSender } from '../lib/postMessager';
import { DefaultWrapper, colors, rem, device } from '../lib/global-styles';
import Modal from '../components/Modal/Modal';
import tv from '../images/img-tv.svg';
import FlashMessage from '../components/FlashMessage';
import ComboGroups from '../components/ComboGroups';

export const ActionButtons = styled.div`
  display: flex;

  button {
    border: none;
    font-size: ${rem(14)};
    font-weight: bold;
    color: ${colors.primary};
    background: none;
    padding: ${rem(20)} ${rem(80)};

    @media ${device.mobile} {
      padding: ${rem(20)} ${rem(45)};
    }
  }

  button:last-child {
    margin-left: auto;
  }
`;

class ProductEdit extends Component {
  state = {
    selectedProduct: null,
    modalContent: {
      image: tv,
      title: '',
      content: '',
    },
  };

  componentDidMount() {
    this.props.onFetchProducts();
  }

  onProductClick = (e, product) => {
    const message = `Tem certeza que deseja mudar para o <span>${
      product.groupName
    } Recorrente</span>?`;
    const { modalContent } = this.state;

    this.setState(
      {
        selectedProduct: product,
        modalContent: { ...modalContent, content: message },
      },
      () => {
        this.props.onShowModal('product-edit-confirmation');
      },
    );

    postMessageSender({
      action: 'productSelected',
      product: {
        id: product.id,
        name: product.groupName,
      },
      scrollTop: true,
    });
  };

  onConfirmClick = () => {
    const { onRequestUpdateProduct } = this.props;
    const { selectedProduct } = this.state;

    onRequestUpdateProduct({ codigo: selectedProduct.id, price_list: selectedProduct.priceListId });
  };

  render() {
    const { modalContent } = this.state;
    const { history, products, onHideModal, flashMessage, subscription } = this.props;
    const availableProducts = products.filter(p => p.id !== subscription.produto.codigo);
    const basicProducts = availableProducts.filter(product => !product.isCombo);

    return (
      <>
        <Header secondary />
        <DefaultWrapper>
          <Title>Opções de compra</Title>
          <Subtitle>
            Escolha o Recorrente que mais combina com você e ganhe até 3 assinaturas digitais.
          </Subtitle>
          <ProductsList products={basicProducts} onProductClick={this.onProductClick} edit />

          <ComboGroups products={availableProducts} />

          <NavButtons>
            <Button onClick={history.goBack} dark noWidth>
              Voltar
            </Button>
          </NavButtons>

          {modalContent.content ? (
            <Modal
              target="product-edit-confirmation"
              targetClass="product-edit-confirmation-modal"
              content={modalContent}
              width={465}
            >
              <hr />
              <ActionButtons>
                <button onClick={onHideModal}>Voltar</button>
                <button onClick={this.onConfirmClick}>Confirmar</button>
              </ActionButtons>
            </Modal>
          ) : null}
          {flashMessage.type ? (
            <Modal target="flash-message" targetClass="flash-message-modal">
              <FlashMessage modal />
            </Modal>
          ) : null}
        </DefaultWrapper>
      </>
    );
  }
}

ProductEdit.propTypes = {
  subscription: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  flashMessage: PropTypes.object.isRequired,
  onFetchProducts: PropTypes.func.isRequired,
  onFetchSubscription: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  subscription: getSubscription(state),
  products: getProducts(state),
  flashMessage: getFlashMessage(state),
});

const mapDispatchToProps = dispatch => ({
  onFetchProducts: () => dispatch(doFetchProducts()),
  onFetchSubscription: () => dispatch(doFetchSubscription()),
  onRequestUpdateProduct: product => dispatch(doRequestUpdateProduct(product)),
  onShowModal: target => dispatch(doShowModal(target)),
  onHideModal: () => dispatch(doHideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProductEdit));
